// extracted by mini-css-extract-plugin
export default {"message":"Message_message__cHc-r","messageCenter":"Message_messageCenter__vmv8G"};